import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentSettings } from '../models/environmentsettings.model';
import { PartCategory } from '../../opc-app/partcategory/partcategory.model';

@Injectable()
export class PartCategoryService {
  addIndex: boolean = true;
    environmentSettings: EnvironmentSettings;
    constructor(private _http: HttpClient) {
        this.environmentSettings = new EnvironmentSettings();
    }
    getPartCategoryById(id: number): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/partcategory/GetPartCategories/' + id);
    }
    getAllPartCategories(): Observable<any> {
        return this._http.get(this.environmentSettings.apiEndPoint + 'api/partcategory/GetAllPartCategories');
    }
    addOrUpdatePartCategory(partCategory: PartCategory, file: any, isNew: boolean): Observable<any> {
        let urlPath = '';
        if (isNew) {
            urlPath = 'api/PartCategory/AddPartCategory';
        } else {
            urlPath = 'api/PartCategory/UpdatePartCategory';
        }
        const data = JSON.stringify(partCategory);
        const formData = new FormData();
        formData.append('partcategory', data);
        if (file) {
            formData.append('file', file, file.name);
        }
        return this._http.post(this.environmentSettings.apiEndPoint + urlPath, formData);
    }
    deletePartCategory(item: number): Observable<any> {
        return this._http.post(this.environmentSettings.apiEndPoint + 'api/PartCategory/DeletePartCategory', item);
  }
  

}



// WEBPACK FOOTER //
// ./src/opc/shared/services/partcategory.service.ts